import React, { useMemo, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import 'features/dashboard/static/downtime/grid/grid.style.css';
import { useCommonInits } from 'hooks/useCommonInits';
import {
    getAssets,
    getUser,
    getGroups,
    getPriceRequest,
    getPriceByPage,
} from 'redux/datasource/dataSourceSlice';
import { useSelector } from 'react-redux';
import { Typography, Button, Box, Paper } from '@mui/material';
import {
    getAllGroups,
    getUserDetail,
    getApcmGroup,
    priceByPage,
    getRequestByGroupIds,
} from 'redux/datasource/dataSourceActions';
import {
    getGroupsbyId,
    getRequestByID,
    getPriceRequestById,
} from 'redux/datasource/dataSourceSlice';
import { useParams } from 'react-router-dom';
import { BrowseHeader } from 'features/browse/browseHeader';
import { ROUTE_PATHS } from 'app/utils/route';

export const AuthExecData = panel => {
    const { id } = useParams();
    const { dispatch, select, navigate } = useCommonInits();
    const Assets = select(getAssets);
    const Groups = useSelector(getGroups);
    const user = select(getUser);
    const GroupByID = useSelector(getGroupsbyId);
    const [executedBy, setExecutedBy] = useState('');
    const [groupId, setGroupId] = useState('');
    const [groupName, setGroupName] = useState('');
    const [confirmed, setConfirmed] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const allRequest = useSelector(getPriceRequest);
    const getRequest = useSelector(getPriceRequestById);
    const request = useSelector(getPriceByPage);
    const [page, setPage] = useState(0);

    useEffect(() => {
        if (Groups) {
            dispatch(getApcmGroup({ id }));
        }
    }, []);

    useEffect(() => {
        getRequestByPage();
    }, [page, pageSize, groupId]);

    // useEffect(() => {
    //     if (user) {
    //         dispatch(getUserDetail());
    //     }
    // }, []);

    useEffect(() => {
        if (allRequest) {
            if (allRequest?.confirmed === 'Y') {
                setConfirmed(true);
            }
        }
    });

    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };

    useEffect(() => {
        if (Groups) {
            dispatch(getAllGroups());
        }
    }, []);

    useEffect(() => {
        if (GroupByID) {
            const params = {
                group_id: GroupByID?._id,
            };
            dispatch(getRequestByGroupIds(params));
            setGroupName(GroupByID?.name);
            setGroupId(GroupByID?._id);
            setExecutedBy(GroupByID?.created_by);
        }
    }, [GroupByID]);

    useEffect(() => {
        setGroupId(GroupByID?._id);
        setGroupName(GroupByID?.name);
    }, []);

    const handleLiveAssets = () => {
        navigateTo(`/${ROUTE_PATHS.assetsLiveData}/${id}`);
    };

    const getRequestByPage = () => {
        const params = {
            page_no: page,
            no_of_records: pageSize,
            group_id: groupId || '',
        };
        dispatch(priceByPage(params));
    };

    const changePage = e => {
        setPage(e);
    };

    const changePageSize = e => {
        setPageSize(Number(e));
    };

    const columns = useMemo(
        () => [
            {
                field: 'date_time',
                headerName: 'Date Time For Execution',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'price_request_name',
                headerName: 'Price Request Name',
                width: 300,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'old_price',
                headerName: 'Old Price',
                width: 150,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'price',
                headerName: 'New Price',
                width: 150,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'confirmed',
                headerName: 'Confirmed',
                width: 150,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
            },
            {
                field: 'executed',
                headerName: 'Executed',
                width: 150,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
            },
            {
                field: 'executed_by',
                headerName: 'Executed By',
                width: 200,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
            },
        ],
        [],
    );

    return (
        <>
            <Paper
                variant="outlined"
                sx={{
                    marginLeft: '8px',
                    marginRight: '8px',
                }}
            >
                <Box>
                    <BrowseHeader />

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography
                            variant={'h6'}
                            style={{ marginLeft: '30px' }}
                        >
                            Group Name : {groupName}
                        </Typography>
                        <div>
                            <Button
                                variant={'outlined'}
                                style={{
                                    marginRight: '20px',
                                    marginBottom: '10px',
                                }}
                                onClick={() => handleLiveAssets()}
                            >
                                Station Status
                            </Button>
                        </div>
                    </div>
                </Box>
            </Paper>
            <Box sx={{ height: '75%', width: '100%', padding: 1 }}>
                <Paper sx={{ width: '100%' }}>
                    <DataGrid
                        disableColumnMenu
                        rows={request}
                        columns={columns}
                        rowCount={getRequest.length}
                        getRowId={row => row._id}
                        rowsPerPageOptions={[10, 25, 50]}
                        autoHeight={true}
                        page={page}
                        pageSize={pageSize}
                        onPageChange={changePage}
                        onPageSizeChange={changePageSize}
                        getRowSpacing={params => ({
                            top: params.isFirstVisible ? 0 : 3,
                            bottom: params.isLastVisible ? 0 : 3,
                        })}
                    />
                </Paper>
            </Box>
        </>
    );
};
